module.exports = __webpack_public_path__ + "static/background-hero-content-448b8cb34921398188a818144f051f06.png";